/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddWorkbookItemRequestDto,
  CreateWorkbookRequestDto,
  ReorderWorkbookItemsRequestDto,
  WorkbookDto,
  WorkbookItemDto,
} from '../models/index';
import {
    AddWorkbookItemRequestDtoFromJSON,
    AddWorkbookItemRequestDtoToJSON,
    CreateWorkbookRequestDtoFromJSON,
    CreateWorkbookRequestDtoToJSON,
    ReorderWorkbookItemsRequestDtoFromJSON,
    ReorderWorkbookItemsRequestDtoToJSON,
    WorkbookDtoFromJSON,
    WorkbookDtoToJSON,
    WorkbookItemDtoFromJSON,
    WorkbookItemDtoToJSON,
} from '../models/index';

export interface WorkbooksAddItemPOSTRequest {
    addWorkbookItemRequestDto?: AddWorkbookItemRequestDto;
}

export interface WorkbooksCreatePOSTRequest {
    createWorkbookRequestDto?: CreateWorkbookRequestDto;
}

export interface WorkbooksDeleteItemDELETERequest {
    id: string;
}

export interface WorkbooksGetBySlugGETRequest {
    slug: string;
    password?: string;
}

export interface WorkbooksReorderPOSTRequest {
    reorderWorkbookItemsRequestDto?: ReorderWorkbookItemsRequestDto;
}

export interface WorkbooksUpdateSettingsPUTRequest {
    id: string;
    createWorkbookRequestDto?: CreateWorkbookRequestDto;
}

/**
 * WorkbooksApi - interface
 * 
 * @export
 * @interface WorkbooksApiInterface
 */
export interface WorkbooksApiInterface {
    /**
     * Creates request options for workbooksAddItemPOST without sending the request
     * @param {AddWorkbookItemRequestDto} [addWorkbookItemRequestDto] 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksAddItemPOSTRequestOpts(requestParameters: WorkbooksAddItemPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {AddWorkbookItemRequestDto} [addWorkbookItemRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksAddItemPOSTRaw(requestParameters: WorkbooksAddItemPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookItemDto>>;

    /**
     */
    workbooksAddItemPOST(requestParameters: WorkbooksAddItemPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookItemDto>;

    /**
     * Creates request options for workbooksCreatePOST without sending the request
     * @param {CreateWorkbookRequestDto} [createWorkbookRequestDto] 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksCreatePOSTRequestOpts(requestParameters: WorkbooksCreatePOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {CreateWorkbookRequestDto} [createWorkbookRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksCreatePOSTRaw(requestParameters: WorkbooksCreatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookDto>>;

    /**
     */
    workbooksCreatePOST(requestParameters: WorkbooksCreatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookDto>;

    /**
     * Creates request options for workbooksDeleteItemDELETE without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksDeleteItemDELETERequestOpts(requestParameters: WorkbooksDeleteItemDELETERequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksDeleteItemDELETERaw(requestParameters: WorkbooksDeleteItemDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    workbooksDeleteItemDELETE(requestParameters: WorkbooksDeleteItemDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for workbooksGetBySlugGET without sending the request
     * @param {string} slug 
     * @param {string} [password] 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksGetBySlugGETRequestOpts(requestParameters: WorkbooksGetBySlugGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} slug 
     * @param {string} [password] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksGetBySlugGETRaw(requestParameters: WorkbooksGetBySlugGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookDto>>;

    /**
     */
    workbooksGetBySlugGET(requestParameters: WorkbooksGetBySlugGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookDto>;

    /**
     * Creates request options for workbooksListMineGET without sending the request
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksListMineGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksListMineGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkbookDto>>>;

    /**
     */
    workbooksListMineGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkbookDto>>;

    /**
     * Creates request options for workbooksReorderPOST without sending the request
     * @param {ReorderWorkbookItemsRequestDto} [reorderWorkbookItemsRequestDto] 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksReorderPOSTRequestOpts(requestParameters: WorkbooksReorderPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {ReorderWorkbookItemsRequestDto} [reorderWorkbookItemsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksReorderPOSTRaw(requestParameters: WorkbooksReorderPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    workbooksReorderPOST(requestParameters: WorkbooksReorderPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for workbooksUpdateSettingsPUT without sending the request
     * @param {string} id 
     * @param {CreateWorkbookRequestDto} [createWorkbookRequestDto] 
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksUpdateSettingsPUTRequestOpts(requestParameters: WorkbooksUpdateSettingsPUTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {CreateWorkbookRequestDto} [createWorkbookRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkbooksApiInterface
     */
    workbooksUpdateSettingsPUTRaw(requestParameters: WorkbooksUpdateSettingsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    workbooksUpdateSettingsPUT(requestParameters: WorkbooksUpdateSettingsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class WorkbooksApi extends runtime.BaseAPI implements WorkbooksApiInterface {

    /**
     * Creates request options for workbooksAddItemPOST without sending the request
     */
    async workbooksAddItemPOSTRequestOpts(requestParameters: WorkbooksAddItemPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Workbooks/items`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddWorkbookItemRequestDtoToJSON(requestParameters['addWorkbookItemRequestDto']),
        };
    }

    /**
     */
    async workbooksAddItemPOSTRaw(requestParameters: WorkbooksAddItemPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookItemDto>> {
        const requestOptions = await this.workbooksAddItemPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkbookItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async workbooksAddItemPOST(requestParameters: WorkbooksAddItemPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookItemDto> {
        const response = await this.workbooksAddItemPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for workbooksCreatePOST without sending the request
     */
    async workbooksCreatePOSTRequestOpts(requestParameters: WorkbooksCreatePOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Workbooks`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWorkbookRequestDtoToJSON(requestParameters['createWorkbookRequestDto']),
        };
    }

    /**
     */
    async workbooksCreatePOSTRaw(requestParameters: WorkbooksCreatePOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookDto>> {
        const requestOptions = await this.workbooksCreatePOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkbookDtoFromJSON(jsonValue));
    }

    /**
     */
    async workbooksCreatePOST(requestParameters: WorkbooksCreatePOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookDto> {
        const response = await this.workbooksCreatePOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for workbooksDeleteItemDELETE without sending the request
     */
    async workbooksDeleteItemDELETERequestOpts(requestParameters: WorkbooksDeleteItemDELETERequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workbooksDeleteItemDELETE().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Workbooks/items/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async workbooksDeleteItemDELETERaw(requestParameters: WorkbooksDeleteItemDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.workbooksDeleteItemDELETERequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workbooksDeleteItemDELETE(requestParameters: WorkbooksDeleteItemDELETERequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workbooksDeleteItemDELETERaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for workbooksGetBySlugGET without sending the request
     */
    async workbooksGetBySlugGETRequestOpts(requestParameters: WorkbooksGetBySlugGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling workbooksGetBySlugGET().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['password'] != null) {
            queryParameters['password'] = requestParameters['password'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Workbooks/{slug}`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async workbooksGetBySlugGETRaw(requestParameters: WorkbooksGetBySlugGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkbookDto>> {
        const requestOptions = await this.workbooksGetBySlugGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkbookDtoFromJSON(jsonValue));
    }

    /**
     */
    async workbooksGetBySlugGET(requestParameters: WorkbooksGetBySlugGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkbookDto> {
        const response = await this.workbooksGetBySlugGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for workbooksListMineGET without sending the request
     */
    async workbooksListMineGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Workbooks`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async workbooksListMineGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkbookDto>>> {
        const requestOptions = await this.workbooksListMineGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkbookDtoFromJSON));
    }

    /**
     */
    async workbooksListMineGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkbookDto>> {
        const response = await this.workbooksListMineGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for workbooksReorderPOST without sending the request
     */
    async workbooksReorderPOSTRequestOpts(requestParameters: WorkbooksReorderPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Workbooks/reorder`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderWorkbookItemsRequestDtoToJSON(requestParameters['reorderWorkbookItemsRequestDto']),
        };
    }

    /**
     */
    async workbooksReorderPOSTRaw(requestParameters: WorkbooksReorderPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.workbooksReorderPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workbooksReorderPOST(requestParameters: WorkbooksReorderPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workbooksReorderPOSTRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for workbooksUpdateSettingsPUT without sending the request
     */
    async workbooksUpdateSettingsPUTRequestOpts(requestParameters: WorkbooksUpdateSettingsPUTRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workbooksUpdateSettingsPUT().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Workbooks/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWorkbookRequestDtoToJSON(requestParameters['createWorkbookRequestDto']),
        };
    }

    /**
     */
    async workbooksUpdateSettingsPUTRaw(requestParameters: WorkbooksUpdateSettingsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.workbooksUpdateSettingsPUTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workbooksUpdateSettingsPUT(requestParameters: WorkbooksUpdateSettingsPUTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workbooksUpdateSettingsPUTRaw(requestParameters, initOverrides);
    }

}
